import { lazy, Suspense } from "react";
import { BookOpen, PiggyBank, Split } from "lucide-react";
import { defineWebModule } from "../../web/module";
import { Loading } from "../../web/ui/kit";
import { canFinanceNow } from "./web/common";
import "./web/finance.css";

// Pages load when opened, so the app starts fast on a phone with weak signal.
const ContactMoneySection = lazy(() => import("./web/Panels").then((m) => ({ default: m.ContactMoneySection })));
const StockMoneySection = lazy(() => import("./web/Panels").then((m) => ({ default: m.StockMoneySection })));

/** The money screens load when someone opens Finances, not with every page. */
const LazyFinances = lazy(() => import("./web/Finances"));

function FinancesSection() {
  return <Suspense fallback={<Loading />}><LazyFinances /></Suspense>;
}

export default defineWebModule({
  id: "finance",
  icons: { budget: PiggyBank, ledger: BookOpen, split: Split },
  ranchSections: { finances: FinancesSection },
  contactSections: [{ id: "finance-money", label: "Money", order: 60, show: () => canFinanceNow(), Component: ContactMoneySection }],
  stockSections: [{ id: "finance-purchases", label: "Purchases", order: 60, show: () => canFinanceNow(), Component: StockMoneySection }],
});
